import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import Toastify from "../container/helper/Toastify";
import api from "../container/helper/Api";
import { useDispatch } from "react-redux";
import { setRegister } from "../container/redux/registerStudentSlice";
// Remove useNavigate import

const OtpVerificationModal = ({
  isOpen,
  onClose,
  onSuccess,
  email,
  registrationData,
  desc,
}) => {
  // Remove navigate declaration
  const dispatch = useDispatch();
  const [emailOtp, setEmailOtp] = useState("");
  const [mobileOtp, setMobileOtp] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(60);

  useEffect(() => {
    if (isOpen) setResendTimer(60);
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen || resendTimer <= 0) return;
    const id = setTimeout(() => setResendTimer((t) => t - 1), 1000);
    return () => clearTimeout(id);
  }, [isOpen, resendTimer]);

  const handleSubmit = async () => {
    if (emailOtp.length !== 4 || mobileOtp.length !== 6) {
      Toastify.error("Please enter valid 4-digit email OTP and 6-digit mobile OTP");
      return;
    }

    setIsLoading(true);
    try {
      const { data, status } = await api.verifyRegisterStudent({
        otp: emailOtp,
        mobileOtp,
        ...registrationData,
      });

      if (status === 200) {
        dispatch(setRegister(true));
        Toastify.success("Student Registered successfully");
        localStorage.setItem("token", data.data.token);
        setEmailOtp("");
        setMobileOtp("");
        onSuccess(); // Call success callback - this will close modals and stay on same page
        // Remove navigate("/courses/Courses");
      }
    } catch (error) {
      Toastify.error(
        error.response?.data?.message || "OTP verification failed"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    if (resendTimer > 0 || resendLoading) return;
    setResendLoading(true);
    try {
      const { status } = await api.resendOtp({
        email: registrationData?.email,
        phone: registrationData?.phone,
      });

      if (status === 200) {
        Toastify.success("OTP resent successfully");
        setEmailOtp("");
        setMobileOtp("");
        setResendTimer(60);
      }
    } catch (error) {
      Toastify.error(error.response?.data?.message || "Failed to resend OTP");
    } finally {
      setResendLoading(false);
    }
  };

  if (!isOpen) return null;

  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1100, // Higher than registration popup
    },
    content: {
      backgroundColor: "white",
      padding: "30px",
      borderRadius: "10px",
      width: "90%",
      maxWidth: "450px",
      position: "relative",
    },
    closeButton: {
      position: "absolute",
      top: "10px",
      right: "10px",
      background: "none",
      border: "none",
      fontSize: "24px",
      cursor: "pointer",
      color: "#666",
    },
    title: {
      fontSize: "24px",
      fontWeight: "600",
      marginBottom: "20px",
      color: "#333",
      textAlign: "center",
    },
    desc: {
      fontSize: "14px",
      color: "#666",
      marginBottom: "20px",
      textAlign: "center",
      lineHeight: "1.5",
    },
    otpInput: {
      width: "100%",
      padding: "15px",
      fontSize: "18px",
      textAlign: "center",
      border: "2px solid #e0e0e0",
      borderRadius: "8px",
      marginBottom: "20px",
      outline: "none",
      transition: "border-color 0.2s",
      letterSpacing: "8px",
      fontWeight: "600",
    },
    buttons: {
      display: "flex",
      gap: "15px",
      marginBottom: "15px",
    },
    cancelBtn: {
      flex: 1,
      padding: "12px",
      backgroundColor: "#f5f5f5",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "500",
      color: "#666",
      transition: "background-color 0.2s",
    },
    submitBtn: {
      flex: 1,
      padding: "12px",
      backgroundColor: "#1D83F8",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "500",
      color: "white",
      transition: "background-color 0.2s",
    },
    submitBtnDisabled: {
      opacity: 0.6,
      cursor: "not-allowed",
    },
    resendContainer: {
      textAlign: "center",
      marginTop: "15px",
    },
    resendBtn: {
      background: "none",
      border: "none",
      color: "#1D83F8",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "500",
      textDecoration: "underline",
    },
  };

  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.content}>
        <button style={modalStyles.closeButton} onClick={onClose}>
          ×
        </button>

        <h3 style={modalStyles.title}>Enter Your OTP</h3>

        {desc && <div style={modalStyles.desc}>{desc}</div>}

        <div style={{ marginBottom: 14 }}>
          <div style={{ marginBottom: 8, fontWeight: 600, color: "#333" }}>Email OTP</div>
            <input
              type="text"
              placeholder="Enter 4-digit email OTP"
              value={emailOtp}
              onChange={(e) => {
                const input = e.target.value;
                if (/^\d{0,4}$/.test(input)) setEmailOtp(input);
              }}
              style={modalStyles.otpInput}
              maxLength="4"
              autoFocus
            />
        </div>

        <div style={{ marginBottom: 20 }}>
          <div style={{ marginBottom: 8, fontWeight: 600, color: "#333" }}>Mobile OTP</div>
          <input
            type="text"
              placeholder="Enter 6-digit mobile OTP"
            value={mobileOtp}
            onChange={(e) => {
              const input = e.target.value;
                if (/^\d{0,6}$/.test(input)) setMobileOtp(input);
            }}
            style={modalStyles.otpInput}
              maxLength="6"
          />
        </div>

        <div style={modalStyles.buttons}>
          <button style={modalStyles.cancelBtn} onClick={onClose}>
            Cancel
          </button>
          <button
            style={{
              ...modalStyles.submitBtn,
              ...(emailOtp.length !== 4 || mobileOtp.length !== 6 ? modalStyles.submitBtnDisabled : {}),
            }}
            onClick={handleSubmit}
            disabled={emailOtp.length !== 4 || mobileOtp.length !== 6 || isLoading}
          >
            {isLoading ? (
              <CircularProgress size={20} thickness={4.5} color="inherit" />
            ) : (
              "Submit"
            )}
          </button>
        </div>

        <div style={modalStyles.resendContainer}>
          Didn't receive OTP?{" "}
          {resendTimer > 0 ? (
            <span style={{ color: "#999" }}>Resend in {resendTimer}s</span>
          ) : (
            <button
              style={modalStyles.resendBtn}
              onClick={handleResendOtp}
              disabled={resendLoading}
            >
              {resendLoading ? "Sending..." : "Resend OTP"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OtpVerificationModal;